import React from "react";
import { Placeholder } from "@bloomberg/media-ui-article";

type PlaceholderImageProps = {
    className?: string;
};

export const PlaceholderImage = (props: PlaceholderImageProps) => {
    const { className } = props;

    return (
        <div className={className}>
            <Placeholder.Image />
            <Placeholder.Image />
        </div>
    );
};

export default PlaceholderImage;
